import { Input, Directive, AfterViewInit, ElementRef } from '@angular/core';

@Directive({
    selector: '[focus]'
})

export class AutofocusDirective {

    @Input() focus: Directive;
    constructor(private element: ElementRef) {
    }

    protected ngOnChanges() {
        if (this.focus) {
            this.element.nativeElement.focus();
        }
    }
}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/directives/autofocus.directive.ts